import { computed, ref } from 'vue'

/** Pull the mobile sheet down past this to close it (the PDP sheets used the same). */
export const FAIR_SHEET_DISMISS_PX = 72

/**
 * Swipe-to-dismiss for the DS mobile sheets (FairDialog Mobile, FairDrawer Mobile):
 * drag the grabber / header down, let go past the threshold to close. A press
 * that starts on a button or a link stays a click.
 */
export function useFairSheetSwipe(options: { enabled: () => boolean; onDismiss: () => void }) {
  const dragY = ref(0)
  let startY = 0
  let dragging = false

  function onPointerDown(event: PointerEvent) {
    if (!options.enabled()) return
    if ((event.target as HTMLElement | null)?.closest('button, a, input, textarea, select')) return
    dragging = true
    startY = event.clientY
    dragY.value = 0
    ;(event.currentTarget as HTMLElement).setPointerCapture?.(event.pointerId)
  }

  function onPointerMove(event: PointerEvent) {
    if (!dragging) return
    dragY.value = Math.max(0, event.clientY - startY)
  }

  function onPointerUp() {
    if (!dragging) return
    const dy = dragY.value
    dragging = false
    dragY.value = 0
    if (dy >= FAIR_SHEET_DISMISS_PX) options.onDismiss()
  }

  const style = computed(() =>
    dragY.value ? { transform: `translateY(${dragY.value}px)`, transition: 'none' } : undefined,
  )

  return {
    style,
    handlers: {
      pointerdown: onPointerDown,
      pointermove: onPointerMove,
      pointerup: onPointerUp,
      pointercancel: onPointerUp,
    },
  }
}
